import { Check, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function Pricing() {
  const plans = [
    {
      name: "Basic",
      price: "Free",
      description: "Perfect for trying out our Text2SQL platform.",
      features: [
        "100 Text to SQL conversions per month",
        "50 SQL to Text explanations per month",
        "Basic community support",
        "Standard response time"
      ],
      notIncluded: [
        "Schema Browser (Coming Soon)",
        "Priority Email Support",
        "Custom Integrations"
      ],
      buttonText: "Get Started",
      buttonLink: "/register",
      popular: false
    },
    {
      name: "Pro",
      price: "$29/mo",
      description: "Ideal for professionals and small teams.",
      features: [
        "Unlimited Text to SQL conversions",
        "Unlimited SQL to Text explanations",
        "Schema Browser (Coming Soon)",
        "Priority Email Support",
        "Fast response time"
      ],
      notIncluded: [
        "Custom Integrations",
        "Dedicated Account Manager"
      ],
      buttonText: "Upgrade to Pro",
      buttonLink: "/register",
      popular: true
    },
    {
      name: "Enterprise",
      price: "Custom",
      description: "For large organizations with custom requirements.",
      features: [
        "Everything in Pro",
        "Custom Integrations (API Access)",
        "Dedicated Account Manager",
        "On-premise deployment options",
        "24/7 Phone Support"
      ],
      notIncluded: [],
      buttonText: "Contact Us",
      buttonLink: "/contact-us",
      popular: false
    }
  ];

  return (
    <div className="min-h-screen bg-slate-50 py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4">Transparent Pricing</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Choose the plan that best fits your needs. Start for free and scale as your data requirements grow.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div 
              key={index} 
              className={`relative bg-white rounded-3xl p-8 border ${plan.popular ? 'border-indigo-500 shadow-xl shadow-indigo-100' : 'border-slate-200 shadow-sm'} flex flex-col`}
            >
              {plan.popular && (
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-indigo-500 text-white px-4 py-1 rounded-full text-sm font-semibold tracking-wide">
                  MOST POPULAR
                </div>
              )}
              <h3 className="text-2xl font-bold text-slate-900 mb-2">{plan.name}</h3>
              <p className="text-slate-500 text-sm mb-6 h-10">{plan.description}</p>
              <div className="text-4xl font-extrabold text-slate-900 mb-8">{plan.price}</div>
              
              <ul className="space-y-4 mb-8 flex-grow">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-start">
                    <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">{feature}</span>
                  </li>
                ))}
                {plan.notIncluded.map((feature, i) => (
                  <li key={i} className="flex items-start text-slate-400">
                    <X className="w-5 h-5 mr-3 flex-shrink-0 mt-0.5" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Link 
                to={plan.buttonLink} 
                className={`w-full py-3 px-6 rounded-xl font-semibold text-center transition-all ${
                  plan.popular 
                  ? 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-md hover:shadow-lg' 
                  : 'bg-slate-100 hover:bg-slate-200 text-slate-900'
                }`}
              >
                {plan.buttonText}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
